import React, { useEffect, useState } from "react";

const VendorFormDrawer = ({
  bodyClassName = "p-0",
  children,
  footer,
  header,
  open,
  onClose,
}) => {
  const [shouldRender, setShouldRender] = useState(open);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let animationFrame;
    let timer;

    if (open) {
      setShouldRender(true);
      animationFrame = window.requestAnimationFrame(() => {
        timer = window.setTimeout(() => setIsVisible(true), 40);
      });
    } else {
      setIsVisible(false);
      timer = window.setTimeout(() => setShouldRender(false), 600);
    }

    return () => {
      window.clearTimeout(timer);
      window.cancelAnimationFrame(animationFrame);
    };
  }, [open]);

  if (!shouldRender) return null;

  return (
    <div className="pointer-events-none fixed inset-y-0 left-[85px] right-0 z-50 flex justify-end overflow-hidden">
      <aside
        className={`pointer-events-auto flex h-full w-full transform-gpu flex-col bg-white shadow-2xl will-change-transform transition-transform duration-[600ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${
          isVisible ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-3">
          <h2 className="text-xl font-semibold text-[#1F2937]">{header}</h2>
          <button
            type="button"
            className="rounded-lg px-3 py-1.5 text-sm font-medium text-[#5B6882] hover:bg-slate-100"
            onClick={onClose}
          >
            Close
            <span className="ml-2 text-xs">x</span>
          </button>
        </div>

        <div className={`min-h-0 flex-1 overflow-y-auto ${bodyClassName}`}>
          {children}
        </div>

        {footer && (
          <div className="shrink-0 border-t border-gray-200 bg-white">
            {footer}
          </div>
        )}
      </aside>
    </div>
  );
};

export default VendorFormDrawer;
